<template>
	<div class="sidebar-limit">
		<div class="sidebar-scroll-container">
		    <div class="sidebar-main">
				<div class="menu-block" :class="$store.state.menuStatus1 == 'true' ? 'open' : ''">
					<div class="menu" v-if="$store.state.menuStatus1 == 'true'" @click="menuFoldClick(1)">
						<p><span>控制台</span><i></i></p>
					</div>
					<div class="menu" v-if="$store.state.menuStatus1 == 'false'" @click="menuopenClick(1)">
						<p><span>控制台</span><i></i></p>
					</div>
					<ul class="sub-menu">
						<li>
							<a :href="domain + '/user/cloud/'"><p class="menu-link-server"><span>云服务器</span></p></a>
							<i class="menu-reminder">云服务器</i>
						</li>
						<li>
							<a :href="domain + '/user/idc/'"><p class="menu-link-idc"><span>租用托管管理</span></p></a>
							<i class="menu-reminder">租用托管管理</i>
						</li>
						<li>
							<a :href="domain + '/user/host/'"><p class="menu-link-host"><span>云虚拟主机</span></p></a>
							<i class="menu-reminder">云虚拟主机</i>
						</li>
						<li :class="$store.state.menuName == 'lb' ? 'active' : ''">
							<a v-bind:href="linkLb"><p class="menu-link-lb"><span>云负载均衡</span></p></a>
							<i class="menu-reminder">云负载均衡</i>
						</li>
						<li :class="$store.state.menuName == 'rds' ? 'active' : ''">
							<a v-bind:href="linkRds"><p class="menu-link-database"><span>云数据库</span></p></a>
							<i class="menu-reminder">云数据库</i>
						</li>
						<li :class="$store.state.menuName == 'mq' ? 'active' : ''">
							<a v-bind:href="linkMq"><p class="menu-link-mq"><span>云消息队列</span></p></a>
							<i class="menu-reminder">云消息队列</i>
						</li>
						<li :class="$store.state.menuName == 'oss' ? 'active' : ''">
							<a v-bind:href="linkOss"><p class="menu-link-oss"><span>对象存储</span></p></a>
							<i class="menu-reminder">对象存储</i>
						</li>
						<li :class="$store.state.menuName == 'dcr' ? 'active' : ''">
							<a v-bind:href="linkDcr"><p class="menu-link-dcr"><span>容器镜像</span></p></a>
							<i class="menu-reminder">容器镜像</i>
						</li>
						<li>
							<a :href="domain + '/user/ssl/'"><p class="menu-link-ssl"><span>SSL证书</span></p></a>
							<i class="menu-reminder">SSL证书</i>
						</li>
						<li>
							<a :href="domain + '/user/domain/'"><p class="menu-link-domain"><span>域名管理</span></p></a>
							<i class="menu-reminder">域名管理</i>
						</li>
						<li :class="$store.state.menuName == 'dns' ? ' active' : ''">
							<a v-bind:href="linkDns"><p class="menu-link-dns"><span>DNS管理</span></p></a>
							<i class="menu-reminder">DNS管理</i>
						</li>
						<li>
							<a :href="domain + '/user/sms/'"><p class="menu-link-sms"><span>短信服务</span></p></a>
							<i class="menu-reminder">短信服务</i>
						</li>
						<li>
							<a :href="domain + '/user/defense/'"><p class="menu-link-defense"><span>攻击防御</span></p></a>
							<i class="menu-reminder">攻击防御</i>
						</li>
						<li>
							<a :href="domain + '/user/oem.index/'"><p class="menu-link-web"><span>百度智能建站</span></p></a>
							<i class="menu-reminder">百度智能建站</i>
						</li>
						<li>
							<a :href="domain + '/user/icp/icpmain/'"><p class="menu-link-icp"><span>网站备案</span></p></a>
							<i class="menu-reminder">网站备案</i>
						</li>
					</ul>
				</div>
				<div class="menu-block" :class="$store.state.menuStatus2 == 'true' ? 'open' : ''">
					<div class="menu" v-if="$store.state.menuStatus2 == 'true'" @click="menuFoldClick(2)">
						<p><span>用户中心</span><i></i></p>
					</div>
					<div class="menu" v-if="$store.state.menuStatus2 == 'false'" @click="menuopenClick(2)">
						<p><span>用户中心</span><i></i></p>
					</div>
					<ul class="sub-menu">
						<li>
							<a :href="domain + '/user/financial/'"><p class="menu-link-finance"><span>财务中心</span></p></a>
							<i class="menu-reminder">财务中心</i>
						</li>
						<li>
							<a :href="domain + '/user/remew/cloud/'"><p class="menu-link-money"><span>续费管理</span></p></a>
							<i class="menu-reminder">续费管理</i>
						</li>
						<li>
							<a :href="domain + '/user/promotion/index/'"><p class="menu-link-promotion"><span>代理分销</span></p></a>
							<i class="menu-reminder">代理分销</i>
						</li>
						<li>
							<a :href="domain + '/user/aws/add/'"><p class="menu-link-workorder"><span>工单管理</span></p></a>
							<i class="menu-reminder">工单管理</i>
						</li>
						<li>
							<a :href="domain + '/user/account'"><p class="menu-link-account"><span>账号设置</span></p></a>
							<i class="menu-reminder">账号设置</i>
						</li>
					</ul>
				</div>
				<div class="menu-block" :class="$store.state.menuStatus3 == 'true' ? 'open' : ''">
					<div class="menu" v-if="$store.state.menuStatus3 == 'true'" @click="menuFoldClick(3)">
						<p><span>精彩活动</span><i></i></p>
					</div>
					<div class="menu" v-if="$store.state.menuStatus3 == 'false'" @click="menuopenClick(3)">
						<p><span>精彩活动</span><i></i></p>
					</div>
					<ul class="sub-menu">
						<li>
							<a :href="domain + '/user/act.actnine/gift'"><p class="menu-link-award"><span>推广活动</span></p></a>
							<i class="menu-reminder">推广活动</i>
						</li>
					</ul>
				</div>
		  	</div>
		</div>
	</div>
</template>

<script setup>
	import { inject } from 'vue';
	import { useStore } from 'vuex';
	
	const domain = inject('domain');
	const accountDomain = inject('accountDomain');
	const store = useStore();
	
	const host = window.location.host;
	let linkLb = '';
	let linkRds = '';
	let linkMq = '';
	let linkDcr = '';
	let linkDns = '';
	let linkOss = '';
	if (host.includes('-p')) {
		linkLb = 'https://lb-p.console.landui.com/';
		linkRds = 'https://rds-p.console.landui.com/';
		linkMq = 'https://mq-p.console.landui.com/';
		linkDcr = 'https://dcr-p.console.landui.com/';
		linkDns = 'https://dns-p.console.landui.com/';
		linkOss = 'https://oss-p.console.landui.com/';
	}else if(host.includes('st')){
		linkLb = 'https://lb.st.landui.cn/';
		linkRds = 'https://rds.st.landui.cn/';
		linkMq = 'https://mq.st.landui.cn/';
		linkDcr = 'https://dcr.st.landui.cn/';
		linkDns = 'https://dnsconsole.st.landui.cn/';
		linkOss = 'https://oss.st.landui.cn/';
	}else if(host.includes('dev')){
		linkLb = 'https://lb.st.landui.cn/';
		linkRds = 'https://rds.st.landui.cn/';
		linkMq = 'https://mq.st.landui.cn/';
		linkDcr = 'https://dcr.st.landui.cn/';
		linkDns = 'http://dnsconsole.zj.dev.landui.cn/';
		linkOss = 'https://oss.st.landui.cn/';
	}else{
		linkLb = 'https://lb.console.landui.com/';
		linkRds = 'https://rds.console.landui.com/';
		linkMq = 'https://mq.console.landui.com/';
		linkDcr = 'https://dcr.console.landui.com/';
		linkDns = 'https://dns.console.landui.com/';
		linkOss = 'https://oss.console.landui.com/';
	}
	
	const menuFoldClick = (e) => {
		switch(e)
		{
			case 1:
				store.commit("setmenuStatus1", 'false');
			break;
			case 2:
				store.commit("setmenuStatus2", 'false');
			break;
			case 3:
				store.commit("setmenuStatus3", 'false');
			break;
		}
	};
	const menuopenClick = (e) =>{
		switch(e)
		{
			case 1:
				store.commit("setmenuStatus1", 'true');
			break;
			case 2:
				store.commit("setmenuStatus2", 'true');
			break;
			case 3:
				store.commit("setmenuStatus3", 'true');
			break;
		}
	}
	
</script>

<style>
	.menu-link-server { background-image: url("../assets/images/menu/menu_icon_server.png"); }
	.router-link-active .menu-link-server, .menu-link-server:hover { background-image: url("../assets/images/menu/menu_icon_server_active.png");}
	.menu-link-idc { background-image: url("../assets/images/menu/menu_icon_idc.png"); }
	.router-link-active .menu-link-idc, .menu-link-idc:hover { background-image: url("../assets/images/menu/menu_icon_idc_active.png"); }
	.menu-link-host { background-image: url("../assets/images/menu/menu_icon_host.png"); }
	.router-link-active .menu-link-host, .menu-link-host:hover { background-image: url("../assets/images/menu/menu_icon_host_active.png"); }
	.menu-link-ssl { background-image: url("../assets/images/menu/menu_icon_ssl.png"); }
	.router-link-active .menu-link-ssl, .menu-link-ssl:hover { background-image: url("../assets/images/menu/menu_icon_ssl_active.png"); }
	.menu-link-domain { background-image: url("../assets/images/menu/menu_icon_domain.png"); }
	.router-link-active .menu-link-domain, .menu-link-domain:hover { background-image: url("../assets/images/menu/menu_icon_domain_active.png"); }
	.menu-link-icp { background-image: url("../assets/images/menu/menu_icon_icp.png"); }
	.router-link-active .menu-link-icp, .menu-link-icp:hover { background-image: url("../assets/images/menu/menu_icon_icp_active.png"); }
	.menu-link-finance { background-image: url("../assets/images/menu/menu_icon_finance.png"); }
	.router-link-active .menu-link-finance, .menu-link-finance:hover { background-image: url("../assets/images/menu/menu_icon_finance_active.png"); }
	.menu-link-cdn { background-image: url("../assets/images/menu/menu_cdn.png"); }
	.router-link-active .menu-link-cdn, .menu-link-cdn:hover { background-image: url("../assets/images/menu/menu_cdn_active.png"); }
	.menu-link-sms { background-image: url("../assets/images/menu/menu_sms.png"); }
	.router-link-active .menu-link-sms, .menu-link-sms:hover { background-image: url("../assets/images/menu/menu_sms_active.png"); }
	.menu-link-bos { background-image: url("../assets/images/menu/menu_bos.png"); }
	.router-link-active .menu-link-bos, .menu-link-bos:hover { background-image: url("../assets/images/menu/menu_bos_active.png"); }
	.menu-link-promotion { background-image: url("../assets/images/menu/menu_promotion.png"); }
	.router-link-active .menu-link-promotion, .menu-link-promotion:hover { background-image: url("../assets/images/menu/menu_promotion_active.png"); }
	.menu-link-award { background-image: url("../assets/images/menu/menu_award.png"); }
	.router-link-active .menu-link-award, .menu-link-award:hover { background-image: url("../assets/images/menu/menu_award_active.png"); }
	.menu-link-database { background-image: url("../assets/images/menu/menu_icon_database.png"); }
	.active .menu-link-database, .menu-link-database:hover { background-image: url("../assets/images/menu/menu_icon_database_active.png"); }
	.menu-link-lb { background-image: url("../assets/images/menu/menu_icon_lb.png"); }
	.active .menu-link-lb, .menu-link-lb:hover { background-image: url("../assets/images/menu/menu_icon_lb_active.png"); }
	.menu-link-mq { background-image: url("../assets/images/menu/menu_icon_mq.png"); }
	.active .menu-link-mq, .menu-link-mq:hover { background-image: url("../assets/images/menu/menu_icon_mq_active.png"); }
	.menu-link-oss { background-image: url("../assets/images/menu/menu_bos.png"); }
	.active .menu-link-oss, .menu-link-oss:hover { background-image: url("../assets/images/menu/menu_bos_active.png"); }
	.menu-link-dcr { background-image: url("../assets/images/menu/menu_icon_dcr.png"); }
	.active .menu-link-dcr, .menu-link-dcr:hover { background-image: url("../assets/images/menu/menu_icon_dcr_active.png"); }
	.menu-link-dns { background-image: url("../assets/images/menu/menu_icon_dns.png"); }
	.active .menu-link-dns, .menu-link-dns:hover { background-image: url("../assets/images/menu/menu_icon_dns_active.png"); }
	.active .menu-link-domain, .menu-link-domain:hover { background-image: url("../assets/images/menu/menu_icon_domain_active.png"); }
	
	
	.menu-link-money { background-image: url("../assets/images/menu/menu_icon_finance.png"); }
	.router-link-active .menu-link-money, .menu-link-money:hover { background-image: url("../assets/images/menu/menu_icon_finance_active.png"); }
	.menu-link-account { background-image: url("../assets/images/menu/menu_icon_user.png"); }
	.router-link-active .menu-link-account, .menu-link-account:hover { background-image: url("../assets/images/menu/menu_icon_user_active.png"); }
	.menu-link-workorder {background-image: url("../assets/images/menu/menu_icon_workorder.png"); }
	.router-link-active .menu-link-workorder, .menu-link-workorder:hover { background-image: url("../assets/images/menu/menu_icon_workorder_active.png"); }
	.menu-link-safe {background-image: url("../assets/images/menu/menu_asse.png"); }
	.router-link-active .menu-link-safe, .menu-link-safe:hover { background-image: url("../assets/images/menu/menu_asse_a.png"); }
	.menu-link-web {background-image: url("../assets/images/menu/menu_icon_web.png"); }
	.router-link-active .menu-link-web, .menu-link-web:hover { background-image: url("../assets/images/menu/menu_icon_web_active.png"); }
	.menu-link-defense {background-image: url("../assets/images/menu/menu_firewall.png"); }
	.router-link-active .menu-link-defense, .menu-link-defense:hover { background-image: url("../assets/images/menu/menu_firewall_a.png"); }
	
	.router-link-active .menu-link-server{ background-image: url("../assets/images/menu/menu_icon_server_active.png"); }
	
	.menu-reminder {
	    display: none;
	    position: absolute;
		left: 66px;
	    top: 50%;
	    width: 114px;
	    height: 32px;
	    margin-top: -16px;
	    padding-left: 16px;
	    line-height: 32px;
	    background: #2d3438;
		border-radius: 4px;
	    color: #fff;
	    text-align: left;
	    font-size: 14px;
	}
	.menu-reminder:before {
	    content: "";
	    position: absolute;
	    left: -12px;
	    top: 50%;
	    border: 6px solid transparent;
	    margin-top: -6px;
	    border-right-color: #2d3438;
	}
</style>
